import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import {
	Popconfirm,
	Input,
	// Button,
	Pagination,
	Row,
	Col,
	Button,
} from 'antd';
import { useDispatch } from 'react-redux';
import { useI18n } from 'hooks/useI18n';
import { SERVER_IP } from 'assets/Config';
import TableComponent from 'components/table-component';
import { deleteApi } from 'redux/sagas/deleteApiSaga';
import EditPayment from 'pages/gym-payments/edit-payment';
import { ReloadOutlined } from '@ant-design/icons';

const GymPaymentListPresentational = ({
	filteredData,
	column,
	tableLoading,
	rowSelection,
	selectedRowKeys,
	currentPage,
	pageSize,
	initialPageSizeOptions,
	initialPageSize,
	handleTableChange,
	setSearchKey,
	getStartingValue,
	getEndingValue,
	paymentAddModal,
	setPaymentAddModal,
	refreshList,
	editPaymentId,
	handleClose,
	paymentType,
	paymentFor,
	onTableChange,
	handlePaginationChange,
	paginationDetails
}) => {
	const dispatch = useDispatch();
	const { t } = useI18n();
	return (
		<>
			<Row>
				<Col span={paymentType ? 24 : 24} style={{}}>
					<TableComponent
						loading={tableLoading}
						className="custom-table"
						style={{ width: '100%' }}
						columns={column}
						bordered
						rowKey={(record) => record.id}
						dataSource={filteredData}
						rowSelection={rowSelection}
						onChange={onTableChange}
						title={() => (
							<Row style={{ justifyContent: 'space-between' }}>
								<Col span={24}>
									<Row gutter={[10, 10]}>
										<Col xl={24}>
											<Row gutter={[10, 10]} align="middle" justify={'space-between'}>
												<Col>
													<Row gutter={[10, 10]}>
														<Col>
															<Input
																placeholder={t('ui.placeholders.search')}
																suffix={<AiOutlineSearch />}
																style={{ height: '30px' }}
																onChange={({ target: { value } }) => setSearchKey(value)}
															/>
														</Col>
														{selectedRowKeys?.length === 1 ? (
															<Col>
																<Popconfirm
																	title={t('gymPayments.delete_confirm')}
																	okText={t('common.delete')}
																	cancelText={t('common.no')}
																	onConfirm={() => {
																		let url = `${SERVER_IP}api/gymPayments/${selectedRowKeys?.[0]}`;
																		dispatch(deleteApi('DELETE_GYM_PAYMENT', url));
																		refreshList(true);
																	}}>
																	<div style={{ textDecoration: 'underline', color: 'red', cursor: 'pointer' }}>
																		{t('common.delete')}
																	</div>
																</Popconfirm>
															</Col>
														) : null}
													</Row>
												</Col>
												<Col>
													{/* <ExcelDownload {...{ ...exportData }} iconOnly /> */}
													<Button
														type="primary"
														icon={<ReloadOutlined />}
														loading={tableLoading}
														onClick={() => refreshList(true)}
														style={{ marginLeft: 10 }}
													/>
												</Col>
											</Row>
										</Col>
									</Row>
								</Col>
								{/* <Col>
									<Button
										// icon={<PlusOutlined />}
										type="primary"
										// style={{ height: '30px', width: '100%' }}
										onClick={handleEditPayment}>
										Create Payment
									</Button>
								</Col> */}
							</Row>
						)}
						pagination={{
							current: currentPage,
							pageSize: pageSize,
							position: ['none', 'none'],
						}}
						footer={() => (
							<Row justify="space-between">
								<Col span={12}>
									{!!paginationDetails?.totalRecords && t('gymPayments.footer.showing_range', { start: getStartingValue(), end: getEndingValue(), total: paginationDetails?.totalRecords })}
								</Col>
								<Col span={12}>
									<div style={{ textAlign: 'right' }}>
										<Pagination
											pageSizeOptions={initialPageSizeOptions}
											defaultPageSize={initialPageSize}
											showSizeChanger={true}
											total={paginationDetails?.totalRecords}
											onChange={handlePaginationChange}
											responsive
										/>
									</div>
								</Col>
							</Row>
						)}
					/>
				</Col>
			</Row>
			<EditPayment {...{ paymentAddModal, setPaymentAddModal, refreshList, editPaymentId, handleClose, paymentFor }} />
		</>
	);
};

export default GymPaymentListPresentational;
